import {USRE_INFO_LOAD} from '../constant/eventbus'

/**
 *
 * @param cb 回调函数
 * @param must_login 是否必须登陆
 */
export function onUseInfoLoad(cb, must_login = true) {
  if (!cb) {
    return;
  }
  if (window.$bus.user.ticket) {
    cb()
  } else {
    window.$bus.$on(USRE_INFO_LOAD, cb);

    //如果不是必须登录才会调用，等待1s，发现仍然没有ticket，则调用一次
    if (!must_login) {
      setTimeout(() => {
        if (!window.$bus.user.ticket) {
          cb();
        }
      }, 1000);
    }
  }
}



// WEBPACK FOOTER //
// ./src/tools/onUseInfoLoad.js